import { render, staticRenderFns } from "./AttendanceHistory.vue?vue&type=template&id=ed6b7d26&scoped=true"
import script from "./AttendanceHistory.vue?vue&type=script&lang=js"
export * from "./AttendanceHistory.vue?vue&type=script&lang=js"
import style0 from "./AttendanceHistory.vue?vue&type=style&index=0&id=ed6b7d26&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6b7d26",
  null
  
)

export default component.exports